import type { IAppDetailsAppData } from '../common-types';
import { styled } from '@mui/material';
import { AppDescription } from '../AppDetails';

const Container = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(3)} 0`,
}));

type DeveloperDescriptionProps = {
  app: IAppDetailsAppData;
  translatedText: {
    developerDescriptionHeading: string;
    developerDescriptionShowMoreButton: string;
    developerDescriptionShowLessButton: string;
  };
};

/**
 * DeveloperDescription from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param translatedText is required, this is the text that as already been translated by the consumer of this component.
 */
export const DeveloperDescription = ({
  app,
  translatedText,
  ...props
}: DeveloperDescriptionProps) => {
  const { developerDescription } = app ?? {};
  return (
    <>
      {developerDescription && developerDescription.length > 0 && (
        <Container {...props}>
          <AppDescription
            title={translatedText?.developerDescriptionHeading}
            descriptionBody={developerDescription}
            showMoreButtonLabel={
              translatedText?.developerDescriptionShowMoreButton
            }
            showLessButtonLabel={
              translatedText?.developerDescriptionShowLessButton
            }
          />
        </Container>
      )}
    </>
  );
};
